import styled from 'styled-components';


//landscape mode:

export const ProfilePageContentsLandscape = styled.div`
    display: flex;
    background: #313238;
    width: 100%;
    min-width: 800px;
    height: ${(props) => props?.isMobile ? `calc(100vh - 40px)` : `100vh`};
    position: fixed;
    top: ${props => props?.isMobile ? '40px' : '0px'};
    left: 0;
    right: 0;
    overflow: hidden;
`;

export const ProfilePageLeftContent = styled.div`
    min-width: 295px;
    width: 295px;
    background: #1E1F23;
    border-radius: 0px 40px 40px 0px;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    
    /* Custom scrollbar */
    ::-webkit-scrollbar {
        width: 6px;
    }
    ::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
        &:hover {
            background: rgba(255, 255, 255, 0.3);
        }
    }
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05);
    
    @media (min-width: 1280px){
        min-width: 350px;
        width: 350px;
    }
`;

export const ProfilePageRightContent = styled.div`
    flex: 1;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    
    /* Custom scrollbar */
    ::-webkit-scrollbar {
        width: 8px;
    }
    ::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
        &:hover {
            background: rgba(255, 255, 255, 0.3);
        }
    }
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05);
`;

// portrait mode:

export const ProfilePageContentsPortrait = styled.div`
    display: flex;
    flex-direction: column;
    background: #313238;
    width: 100%;
    position: absolute;
    top: ${props => props?.isMobile ? '40px' : '0px'};
    min-height: ${props => props?.isMobile ? `calc(100% - 40px)` : '100%'};
`;

export const ProfileContainer = styled.div`
    @media (orientation: portrait){
        ${ProfilePageContentsLandscape}{
            display: none;
        }
    }
    @media (orientation: landscape){
        ${ProfilePageContentsPortrait}{
            display: none;
        }
    }
`;

export const ProfilePagePortraitUpperContainer = styled.div`
    width: 100%;
    padding: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgba(0, 0, 0, 0.50);
    position: relative;
    @media (max-width: 768px) {
        padding: 10px 25px;
    }
`;

export const ProfilePagePortraitLowerContainer = styled.div`
    background: #313238;
    display: flex;
    flex-direction: column;
    color: #FFF;
    padding-top: 15px;
`

export const StickyMenu = styled.div`
    position: sticky;
    top: ${props => props?.isMobile ? '80px' : '50px'};
    display: flex;
    overflow: auto;
    gap: 25px;
    background: #313238;
    z-index: 3;
    padding: 0 25px 10px 25px;
    /* Hide scrollbar for Chrome, Safari and Opera */
    ::-webkit-scrollbar {
        display: none;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none; /* Firefox */
`

export const StickyMenuOption = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    flex-grow: 0;
    cursor: pointer;
    color: ${props => props?.isSelected ? '#4BAFFE' : '#ABABAB'};
    font-size: 12px;
    font-family: Outfit;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`

export const StickyMenuOptionIcon = styled.img`
    width: 20px;
    height: 20px;
    margin-right: 5px;
`

export const StyledDefaultPage = styled.div`
    width: 100%;
    height: 100%;
    align-items: center;
    display: flex;
    flex-direction: column;
`;

export const StyledDefaultText = styled.div`
    font-family: 'heroregular';
    font-style: normal;
    font-weight: 400;
    font-size: 38px;
    line-height: 46px;
    letter-spacing: 0.04em;
    color: #FFFFFF;
`;
